import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/home/index',
    component: () => import(/* webpackChunkName: "about" */ '../views/front/HomeView.vue'),
    children: [
      {
        path: '/home/index',
        name: 'netSchool',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/IndexView.vue'),
      },
      {
        path: '/course/list',
        name: 'courseList',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/CourseListView.vue'),
      },
      {
        path: '/teacher/list',
        name: 'teacherList',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/TeacherListView.vue'),
      },
      {
        path: '/course/details',
        name: 'courseDetails',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/CourseDetailsView.vue'),
      },
      {
        path: '/teacher/details',
        name: 'teacherDetails',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/TeacherDetailsView.vue'),
      },
      {
        path: '/coursePackage/list',
        name: 'coursePackageList',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/CoursePackageListView.vue'),
      },
      {
        path: '/question/bank',
        name: 'questionBank',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/QuestionBankView.vue'),
      },
      {
        path: '/subject/list',
        name: 'subjectList',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/SubjectListView.vue'),
      },
      {
        path: '/subject/details',
        name: 'subjectDetails',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/SubjectDetailsView.vue'),
      },
      {
        path: '/personal',
        name: 'personal',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/Personal.vue'),
      },
      {
        path: '/video',
        name: 'video',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/TCPlayerView.vue'),
      },
      {
        path: '/order/pay',
        name: 'pay',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/CoursePayView.vue'),
      },
      {
        path: '/pay/qrcode',
        name: 'qrcode',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/WxPayQrcodeView.vue'),
      },
      {
        path: '/coursePackage/detail',
        name: 'coursePackageDetail',
        component: () => import(/* webpackChunkName: "about" */ '../views/front/CoursePackageDetailView.vue'),
      },
    ]
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
